module.exports = __webpack_public_path__ + "static/media/ideologiq_background.92bb12fa.mp4";